// Modules
import ReactPaginate from "react-paginate";

// Hooks
import usePagination from "hooks/searchPage/usePagination";

// Redux
import { useAppSelector } from "redux/hooks";
import { forcePageSelector } from "redux/searchPage/pagination/paginationSlice";
import { urlPathSelector } from "redux/searchPage/filters/filtersSlice";

// Utils
import { changePageNumberInQueryString } from "utils/searchPage/queryString";

const Pagination = () => {
	const forcePage = useAppSelector(forcePageSelector);
	const urlPath = useAppSelector(urlPathSelector);
	const { pageCount, currentPage, currentPageMobile, handleDoubleChevron, onClickPagination, buildMobileHref } = usePagination(urlPath);

	return (
		<>
			<div className="wk-desktop-pagination wk-hide-mobile">
				{pageCount > 1 && (
					<>
						{currentPage > 0 && (
							<a
								className="wk-icon-chevron-double-left"
								href={`/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}/${changePageNumberInQueryString(urlPath, 1)}`}
								onClick={(event) => handleDoubleChevron(event, 0)}
							/>
						)}
						<ReactPaginate
							containerClassName="list-item"
							breakLabel="..."
							nextLabel={" "}
							nextLinkClassName={currentPage < pageCount - 1 ? "wk-icon-chevron-right" : ""}
							onClick={(numberPage) => onClickPagination(numberPage)}
							hrefBuilder={(numberPage) => `/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}/${changePageNumberInQueryString(urlPath, numberPage)}`}
							pageRangeDisplayed={5}
							marginPagesDisplayed={1}
							pageCount={pageCount}
							previousLabel={" "}
							previousLinkClassName={currentPage > 0 ? "wk-icon-chevron-left" : ""}
							initialPage={forcePage === null ? currentPage : undefined}
							activeLinkClassName="wk-active"
							forcePage={forcePage ?? undefined}
						/>
						{currentPage < pageCount - 1 && (
							<a
								className="wk-icon-chevron-double-right"
								href={`/${process.env.NEXT_PUBLIC_SEARCH_PATH_NAME}/${changePageNumberInQueryString(urlPath, pageCount)}`}
								onClick={(event) => handleDoubleChevron(event, pageCount - 1)}
							/>
						)}
					</>
				)}
			</div>
			{pageCount > 0 && (
				<div className="wk-mobile-pagination wk-hide-not-mobile">
					<a
						className="wk-backward"
						href={buildMobileHref(true)}
						onClick={(event) => {
							event.preventDefault();
							onClickPagination(currentPageMobile, true, true);
						}}
					>
						<span className="wk-icon-chevron-left" />
						Indietro
					</a>
					<a
						className="wk-forward"
						href={buildMobileHref()}
						onClick={(event) => {
							event.preventDefault();
							onClickPagination(currentPageMobile, true);
						}}
					>
						Avanti
						<span className="wk-icon-chevron-right" />
					</a>
				</div>
			)}
		</>
	);
};

export default Pagination;
